import { UseFormReturn, Controller } from "react-hook-form";
import TextField from "@/components/TextField";
import Button from "@/components/Button";
import Select from "@/components/Select";
import classNames from "classnames";

interface OverallFeedbackFormData {
  overallFeedback: string;
  eventRating: number;
}

interface EditOverallFeedbackCardProps {
  form: UseFormReturn<OverallFeedbackFormData>;
  onSubmit: (formData: OverallFeedbackFormData) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export default function EditOverallFeedbackCard({
  form,
  onSubmit,
  onCancel,
  isSubmitting
}: EditOverallFeedbackCardProps) {
  return (
    <div className="space-y-6 w-full">
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="overallFeedback"
          render={({ field }) => (
            <TextField
              label="Overall Feedback"
              type="textarea"
              rows={4}
              value={field.value}
              onChange={(e) => field.onChange((e.target as HTMLInputElement)?.value || "")}
              supportingText="Please include suggestions for improvements/reminders if attending in the future"
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="eventRating"
          render={({ field }) => (
            <Select
              label="Event Rating"
              value={field.value?.toString() || ""}
              onSelect={(value: string) => field.onChange(parseInt(value) || 0)}
              supportingText="Rate the effectiveness of this event for PGA Recruiting"
              options={[
                { value: "1", label: "1 - No value / poor turnout" },
                { value: "2", label: "2 - Low value / low turnout" },
                { value: "3", label: "3 - Mixed value / ok turnout" },
                { value: "4", label: "4 - Solid value / good turnout" },
                { value: "5", label: "5 - High value / great turnout" }
              ]}
            />
          )}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outlined" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          iconClassName={classNames(isSubmitting && "animate-spin w-6 h-6 !block")}
          disabled={isSubmitting}
          icon={isSubmitting ? "progress_activity" : undefined}
          onClick={() => onSubmit(form.getValues())}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
